<template>
  <div class="quick-reply-container">
    <div class="quick-reply-level1">
      <span
        v-for="item in templates"
        :key="item.code"
        @click="handleLevel1Click(item)"
        class="quick-reply-tag-wrapper"
      >
        <el-tooltip :content="item.title" placement="top" :open-delay="500">
          <el-tag
            class="tag-green"
            :class="{
              'tag-expandable': hasMultipleChildren(item),
              'tag-expanded': expandedCode === item.code && hasMultipleChildren(item),
              'tag-child': hasSingleChild(item),
            }"
          >
            {{ item.title }}
            <i
              v-if="hasMultipleChildren(item)"
              class="el-icon-arrow-down quick-reply-arrow"
              :class="{ 'arrow-up': expandedCode === item.code }"
            ></i>
          </el-tag>
        </el-tooltip>
      </span>
    </div>
    <transition name="accordion">
      <div
        v-if="expandedItem"
        :key="expandedItem.code"
        class="quick-reply-children"
      >
        <span
          v-for="child in expandedItem.children"
          :key="child.code"
          @click="$emit('select', child.content)"
          class="quick-reply-tag-wrapper"
        >
          <el-tooltip :content="child.title" placement="top" :open-delay="500">
            <el-tag class="tag-green tag-child">{{ child.title }}</el-tag>
          </el-tooltip>
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
import { Tag, Tooltip } from 'element-ui';

export default {
  name: 'MassageSuggest',
  props: {
    templates: { type: Array, default: () => [] },
    expandedCode: { type: String, default: null },
  },
  components: {
    [Tag.name]: Tag,
    [Tooltip.name]: Tooltip,
  },
  computed: {
    expandedItem() {
      if (!this.expandedCode) return null;
      const item = this.templates.find(t => t.code === this.expandedCode);
      return item && item.children && item.children.length > 1 ? item : null;
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    hasSingleChild(item) {
      return item.children && item.children.length === 1;
    },
    hasMultipleChildren(item) {
      return item.children && item.children.length > 1;
    },
    handleLevel1Click(item) {
      if (this.hasMultipleChildren(item)) {
        this.$emit('toggle', item.code);
      } else if (this.hasSingleChild(item)) {
        this.$emit('select', item.children[0].content);
      } else {
        this.$emit('select', item.content);
      }
    },
    handleClickOutside(e) {
      if (this.expandedCode && !this.$el.contains(e.target)) {
        this.$emit('toggle', this.expandedCode);
      }
    },
  },
};
</script>

<style scoped>
.quick-reply-container {
  display: flex;
  flex-direction: column;
}

.quick-reply-level1 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.quick-reply-tag-wrapper {
  display: inline-block;
}

.quick-reply-children {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: 8px 0;
  margin-bottom: 8px;
  border-bottom: 1px solid #dcdfe6;
  overflow: hidden;
}

span.el-tag.tag-green {
  cursor: pointer;
  padding: 0 12px;
  height: 40px;
  line-height: 38px;
  font-size: 20px;
  margin-bottom: 8px;
  margin-right: 5px;
  background: #00978bd4;
  color: #fff;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  border: none;
  position: relative;
}

span.el-tag.tag-green.tag-expandable {
  background: #fff;
  color: #00978b;
  border: 2px solid #00978bd4;
}

span.el-tag.tag-green.tag-expanded {
  background: #fff;
  color: #00978b;
  border: 2px solid #00978bd4;
}

span.el-tag.tag-green.tag-child {
  background: #006b5fd4;
  width: 180px;
  height: 36px;
  line-height: 34px;
  font-size: 18px;
}

.quick-reply-arrow {
  font-size: 20px;
  margin-left: 6px;
  transition: transform 0.2s;
  font-weight: bold;
}

.quick-reply-arrow.arrow-up {
  transform: rotate(180deg);
}

/* Accordion transition — enter only, leave is instant */
.accordion-enter-active {
  transition: opacity 0.25s, max-height 0.25s;
  max-height: 500px;
}

.accordion-enter {
  opacity: 0;
  max-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MassageSuggest.vue